import React, { Component } from 'react';
import FakeData from '.././fake-data';
import { Link } from 'react-router-dom';

import Geosuggest from 'react-geosuggest';

import './GroupMembers.css';
import { EventViewSplitPane } from './Event'
import { Modal, ComboBox, PublicityPicker, PhonePicker, ConfirmModal, EmptyState } from './Common';

export default class GroupMembers extends Component {
    constructor(p) {
        super(p)
        this.state = {
            activeTab: "Members",
            userTabs: ["Members", "Admins", "Requests"],
            isAdding: false,
            isDeleting: false,
            memberToRemove: null,
            deleteCB: null,
            isRemovingAdmin: false,
            deleteAdminCB: null,
            adminToRemove: null,
            filter: ""
        }
    }

    onChange = (e) => {
        this.setState({ filter: e.target.value });
    }

    filterData = () => {
        const { filter } = this.state;
        const { profile, isAdmin, users } = this.props;
        const list = FakeData.listify(users).filter((item) => {
            return item.name.toLowerCase().indexOf(filter.toLowerCase()) > -1;
        })

        return list;
    }

    filterRequests = () => {
        const { filter } = this.state;
        const { profile, isAdmin, users } = this.props;
        const list = FakeData.listify(profile.requests).filter((item) => {
            return item.name.toLowerCase().indexOf(filter.toLowerCase()) > -1;
        })

        return list;
    }

    removeMember = (user, cb) => {
        const _that = this;
        const { profile, isAdmin, users } = this.props;
        if (user.role === "admin" && this.getAdmins().length <= 1) {
            FakeData.alert("Can not remove the last admin of this group, try adding more!")
            cb.call(this)
            return;
        }
        const data = {
            userId: user.id,
            userType: user.type,
            memberId: user.memberId,
            groupId: profile.id,
            role: user.role
        }

        //console.log(data)
        FakeData.post("/removeMember.php?auth0", data, {
            success(res) {
                if (res.error) {
                    FakeData.alert("Couldn't remove member from group! Try again later!")
                } else {
                    FakeData.alert("Member was successfully removed from this group!")
                }

                cb.call(this)
            },
            error(err) {
                FakeData.alert("Couldn't remove member from group! Try again later!")
                cb.call(this)
            }
        }, true, "", (r) => { })
    }

    toggleAdmin = (user, role, cb) => {
        const _that = this;
        if (role === "member" && user.role === "admin" && this.getAdmins().length <= 1) {
            FakeData.alert("Can not remove the last admin of this group, try adding more!")
            cb.call(this)
            return;
        }
        const { profile, isAdmin, users } = this.props;
        const data = {
            id: user.memberId,
            user: {
                id: FakeData.getData("yoo").id,
                type: "F"
            },
            userTo: user,
            group: profile,
            role: role
        }

        //console.log(data)
        FakeData.post("/changeMemberStatus.php?auth0", data, {
            success(res) {
                if (res.error) {
                    FakeData.alert("Couldn't peform action! Try again later!")
                } else {
                    FakeData.alert("Member role was successfully updated!")
                }

                cb.call(this)
            },
            error(err) {
                FakeData.alert("Couldn't peform action! Try again later!")
                cb.call(this)
            }
        }, true, "", (r) => { })
    }

    cancel = (user) => {
        const { profile } = this.props
        
        const _that = this;

        const data = {
            user:FakeData.getData("yoo"),
            userId: user.id,
            userType: user.type,
            joinId: user.joinId,
            groupId: profile.id,
        }

        //console.log(data)
        FakeData.post("/removeGroupForumRequest.php?auth0", data, {
            success(res) {
                if (res.error) {
                    FakeData.alert("Couldn't remove request! Try again later!")
                    _that.setState({
                        isRemoving: false
                    })
                } else {
                    //FakeData.alert("Member was successfully removed from this group!")
                    _that.setState({
                        isRemoving: false
                    })
                }
            },
            error(err) {
                FakeData.alert("Couldn't remove request! Try again later!")
                _that.setState({
                    isRemoving: false
                })
            }
        }, true, "", (r) => { })
    }

    approve = (user) => {
        //approveGroupForumRequest.php
        const { profile } = this.props
        
        const _that = this;

        const data = {
            user:FakeData.getData("yoo"),
            userId: user.id,
            userType: user.type,
            joinId: user.joinId,
            groupId: profile.id,
        }

        //console.log(data)
        FakeData.post("/approveGroupForumRequest.php?auth0", data, {
            success(res) {
                if (res.error) {
                    FakeData.alert("Couldn't approve request! Try again later!");
                } else {
                    FakeData.alert("Member was successfully added to this group!");
                }
            },
            error(err) {
                FakeData.alert("Couldn't approve request! Try again later!");
            }
        }, true, "", (r) => { })
    }

    getAdmins = () => {
        const { profile, isAdmin, users } = this.props;
        const list = FakeData.listify(users).filter((item) => {
            return item.role === "admin";
        })

        return list;
    }

    getMembers = () => {
        const { profile, isAdmin, users } = this.props;
        const list = FakeData.listify(users).filter((item) => {
            return item.role !== "admin";
        })

        return list;
    }

    render() {
        const { profile, isAdmin, users } = this.props;
        const { activeTab, isAdding, isDeleting, memberToRemove, deleteCB, isRemovingAdmin, deleteAdminCB, adminToRemove, filter } = this.state;
        const _that = this;
        const normalYou = [
            {
                label: "Leave Group",
                click: (item, cb) => {
                    _that.setState({
                        isDeleting: true,
                        deleteCB: cb,
                        memberToRemove: item
                    })
                }
            }
        ];

        const adminYou = [
            {
                label: "Remove Admin",
                click: (item, cb) => {
                    _that.setState({
                        isRemovingAdmin: true,
                        deleteAdminCB: cb,
                        adminToRemove: item
                    })
                }
            },
            {
                label: "Leave Group",
                click: (item, cb) => {
                    _that.setState({
                        isDeleting: true,
                        deleteCB: cb,
                        memberToRemove: item
                    })
                }
            }
        ];

        const adminNormal = [
            {
                label: "Make Admin",
                click: (item, cb) => {
                    _that.toggleAdmin(item, "admin", cb)
                }
            },
            {
                label: "Remove Member",
                click: (item, cb) => {
                    _that.setState({
                        isDeleting: true,
                        deleteCB: cb,
                        memberToRemove: item
                    })
                }
            }
        ];

        const adminOther = [
            {
                label: "Remove Admin",
                click: (item, cb) => {
                    _that.setState({
                        isRemovingAdmin: true,
                        deleteAdminCB: cb,
                        adminToRemove: item
                    })
                }
            },
            {
                label: "Remove Member",
                click: (item, cb) => {
                    _that.setState({
                        isDeleting: true,
                        deleteCB: cb,
                        memberToRemove: item
                    })
                }
            }
        ]

        const joinActs = [
            {
                label: "Approve",
                click: (item, cb) => {
                   this.approve(item)
                }
            },
            {
                label: "Decline",
                click: (item, cb) => {
                    this.cancel(item)
                }
            }
        ]

        return (
            <div className="default-view" style={{ backgroundColor: "#fff", marginTop: "10px", paddingBottom: "20px" }}>
                <div className="view-with-tabs">
                    <div className="view-with-tabs-head">
                        {
                            this.state.userTabs.map((item, i) => {
                                const count = item === "Admins" ? this.getAdmins().length : item === "Members" ? this.getMembers().length : FakeData.listify(profile.requests).length
                                if((!isAdmin || (!profile.isMember && !profile.isApproval) || profile.requests.length===0) && item==="Requests"){
                                    return null;
                                }
                                return (
                                    <div key={i} className={(item === this.state.activeTab) ? "view-with-tabs-head-item group-mem-count-holder active" : "view-with-tabs-head-item group-mem-count-holder"} onClick={() => this.setState({ activeTab: item, filter: "" })}>
                                        {item}
                                        <span className="group-mem-count">{FakeData.shortDigit(count, "").text}</span>
                                    </div>
                                )
                            })
                        }
                    </div>
                    <div className="view-with-tabs-body">
                        {activeTab !== "Requests" &&
                            <div className="group-members-view-list-filter">
                                {!isAdding &&
                                    <div className="group-members-view-list-filter-search">
                                        <input value={filter} placeholder="Find member" onChange={this.onChange.bind(this)} />
                                        <i className="material-icons">search</i>
                                    </div>
                                }
                                {((!isAdding && isAdmin) || (!isAdding && profile.isMember && profile.isApproval)) && <span style={{ marginRight: "10px" }}>or</span>}
                                {((!isAdding && isAdmin) || (!isAdding && profile.isMember && profile.isApproval)) && <button onClick={() => this.setState({ isAdding: true })}>Add</button>}
                                {((isAdding && isAdmin) || (isAdding && profile.isMember && profile.isApproval)) &&
                                    <div>
                                        <GroupInvitesPicker group={profile} users={users} />
                                    </div>
                                }
                                {((isAdding && isAdmin) || (isAdding && profile.isMember && profile.isApproval)) && <span style={{ margin: "0px 10px" }}>or</span>}
                                {((isAdding && isAdmin) || (isAdding && profile.isMember && profile.isApproval)) && <button onClick={() => this.setState({ isAdding: false })}>Search</button>}
                            </div>
                        }
                        {activeTab === "Requests" &&
                            <div className="group-members-view-list-filter">
                                <div className="group-members-view-list-filter-search">
                                    <input value={filter} placeholder="Find member" onChange={this.onChange.bind(this)} />
                                    <i className="material-icons">search</i>
                                </div>
                            </div>
                        }
                        {this.i && <EmptyState isShown={(FakeData.listify([]).length === 0) ? true : false} text="No videos were found!" icon="theaters" />}
                        {activeTab === "Members" &&
                            <div className="group-members-view-list">
                                {
                                    FakeData.listify(this.filterData()).map((item, i) => {
                                        if (item.role === "admin") {
                                            return null;
                                        }
                                        return (
                                            <Member
                                                key={item.memberId}
                                                item={item}
                                                actions={isAdmin ? adminNormal : (FakeData.getData("yoo").id === item.id) ? normalYou : []} />
                                        )
                                    })
                                }
                            </div>
                        }
                        {activeTab === "Admins" &&
                            <div className="group-members-view-list">
                                {
                                    FakeData.listify(this.filterData()).map((item, i) => {
                                        if (item.role !== "admin") {
                                            return null;
                                        }
                                        return (
                                            <Member
                                                key={item.memberId}
                                                item={item}
                                                actions={isAdmin && FakeData.getData("yoo").id === item.id ? adminYou : isAdmin ? adminOther : []} />
                                        )
                                    })
                                }
                            </div>
                        }
                        {activeTab === "Requests" &&
                            <div className="group-members-view-list">
                                {
                                    FakeData.listify(profile.requests).map((item, i) => {
                                        return (
                                            <Member
                                                key={item.joinId}
                                                item={item}
                                                actions={joinActs} />
                                        )
                                    })
                                }
                            </div>
                        }
                    </div>
                </div>
                {(isDeleting && memberToRemove !== null) &&
                    <ConfirmModal message="Are you sure you want to remove this member from this group?<br/>" isOpen={isDeleting} data={memberToRemove}
                        onOkay={(data) => {
                            this.removeMember(data, () => {
                                //deleteCB.call(this)
                                this.setState({
                                    isDeleting: false,
                                    deleteCB: null,
                                    memberToRemove: null
                                })
                            })
                        }}
                        onCancel={() => {
                            this.setState({
                                isDeleting: false,
                                deleteCB: null,
                                memberToRemove: null
                            })
                        }} />
                }
                {(isRemovingAdmin && adminToRemove !== null) &&
                    <ConfirmModal message="Are you sure you want to change this member's role on this group?<br/>" isOpen={isRemovingAdmin} data={adminToRemove}
                        onOkay={(data) => {
                            this.toggleAdmin(data, "member", () => {
                                //deleteAdminCB.call(this)
                                this.setState({
                                    isRemovingAdmin: false,
                                    deleteAdminCB: null,
                                    adminToRemove: null
                                })
                            })
                        }}
                        onCancel={() => {
                            this.setState({
                                isRemovingAdmin: false,
                                deleteAdminCB: null,
                                adminToRemove: null
                            })
                        }} />
                }
            </div>
        );
    }
}

class Member extends Component {
    render = () => {
        const { item, actions } = this.props
        return (
            <div className="group-members-view-list-item">
                <img src={item.image} />
                <span>
                    <span>{item.name}</span>
                    <span>{(item.isNew && item.role !== "admin") ? "New Member" : item.role.capitalize()}</span>
                </span>
                {actions.length > 0 &&
                    <div tabIndex={0} ref="options">
                        <i className="material-icons">settings</i>
                        <div className="group-members-view-list-item-actions">
                            {
                                actions.map((_item, i) => {
                                    return (
                                        <span key={i} onClick={() => {
                                            _item.click(item, () => {
                                                //this.refs.options.blur()
                                            })
                                        }}>{_item.label}</span>
                                    )
                                })
                            }
                        </div>
                    </div>
                }
            </div>
        )
    }
}

class GroupInvitesPicker extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filter: "",
            users: [],
            isFocus: false
        }
    }

    onChange = (e) => {
        this.setState({ filter: e.target.value });
    }

    filterData = () => {
        const { filter } = this.state;
        const { users } = this.props
        if (filter === "") {
            return [];
        }
        const list = FakeData.listify(FakeData.getData("yoo").friends).filter((item) => {
            return item.name.toLowerCase().indexOf(filter.toLowerCase()) > -1 && !this.inSelection(item, users);
        })

        return list;
    }

    add = (user) => {
        const { users, group } = this.props
        const _that = this;
        const data = {
            user: {
                id: FakeData.getData("yoo").id,
                type: "F"
            },
            userTo: user,
            group
        }

        //console.log(data)

        FakeData.post("/addGroupMember.php?auth0", data, {
            success(res) {
                if (res.error) {
                    FakeData.alert("Couldn't add member to group! Try again later!")
                } else {
                    FakeData.alert("Member was successfully added to this group!")
                }
            },
            error(err) {
                FakeData.alert("Couldn't add member to group! Try again later!")
            }
        }, true, "", (r) => { })
    }

    inSelection = (user, users) => {
        let bool = false;
        for (var i = 0; i < users.length; i++) {
            if (users[i].id === user.id) {
                bool = true;
                break;
            }
        }

        return bool;
    }

    render = () => {
        const { error, users } = this.props;
        const { filter, isFocus } = this.state
        return (
            <div className={error ? "event-invite-pk error" : "event-invite-pk"} tabIndex={0}>
                <span className="event-invite-pk-input">
                    <input placeholder="Search friend to add" tabIndex={1} value={filter} onChange={this.onChange.bind(this)} />
                    {filter !== "" &&
                        <i className="material-icons" onClick={() => this.setState({ filter: "" })}>close</i>
                    }
                    <i className="material-icons">search</i>
                </span>
                <div className="event-invite-pk-list" style={{ display: (this.filterData().length > 0) ? "" : "none" }} tabIndex={0}>
                    {
                        this.filterData().map((item, i) => {
                            return (
                                <div key={i} className={this.inSelection(item, users) ? "event-invite-pk-list-item active" : "event-invite-pk-list-item"}>
                                    <img src={item.image} />
                                    <span>{item.name}</span>
                                    <button onClick={() => this.add(item)}>Add</button>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        )
    }

}


// WEBPACK FOOTER //
// ./src/components/GroupMembers.jsx